import { render, staticRenderFns } from "./LeaveRegister.vue?vue&type=template&id=0960f0c2&scoped=true"
import script from "./LeaveRegister.vue?vue&type=script&lang=js"
export * from "./LeaveRegister.vue?vue&type=script&lang=js"
import style0 from "./LeaveRegister.vue?vue&type=style&index=0&id=0960f0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960f0c2",
  null
  
)

export default component.exports